import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { React } from 'libs/react';
import './Check.scss';
/**
 * @component Check
 * @since 1.0.0
 * @hidden
 */
export function Check(props) {
    const { type, name, ident, outer, checked, required, disabled } = Object.assign({ type: 'checkbox' }, props);
    const node = useRef(null);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(e) {
        if (props.onChange) {
            props.onChange(e.currentTarget.checked);
        }
    }
    /**
     * @function onOuterClick
     * @since 1.0.0
     * @hidden
     */
    function onOuterClick() {
        const input = node.current;
        if (input == null) {
            return;
        }
        input.checked = !input.checked;
        if (props.onChange) {
            props.onChange(input.checked);
        }
    }
    useEffect(() => {
        if (outer && outer.current) {
            outer.current.addEventListener('click', onOuterClick);
        }
        return () => {
            if (outer && outer.current) {
                outer.current.removeEventListener('click', onOuterClick);
            }
        };
    }, []);
    return (React.createElement("input", { id: ident, ref: node, type: type, name: name, checked: checked, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange, onClick: (e) => e.stopPropagation() }));
}
